<template>
  <span class="timer">
    Осталось ещё

    <span
      v-if="returnTimer.days"
    >
      {{ returnTimer.days }}
    </span>

    {{ returnTimer.time }}
  </span>
</template>

<script setup lang="ts">
  import { pluralize } from '@academica-box/utils/scripts/pluralize'

  const props = withDefaults(defineProps<{
    timer?: number;
    format?: string;
  }>(), {
    timer: 0,
    format: 'dd:hh:mm:ss'
  })

  const emit = defineEmits(['end-days', 'timer-end'])

  const interval = ref<ReturnType<typeof setInterval> | null>(null)
  const timerValues = ref({
    seconds: 0,
    minutes: 0,
    hours: 0,
    days: 0
  })

  const returnTimer = computed(() => {
    const days = timerValues.value.days
    const daysWord = pluralize(days, ['день', 'дня', 'дней'])
    const hours = getTimeStringValue(timerValues.value.hours)
    const minutes = getTimeStringValue(timerValues.value.minutes)
    const seconds = getTimeStringValue(timerValues.value.seconds)

    let time: {
      days: string| null;
      time: string;
    } = {
      days: days ? `${days} ${daysWord}` : null,
      time: `${hours}:${minutes}:${seconds}`
    }

    if (props.format === 'hh:mm:ss') {
      time = {
        days: null,
        time: `${hours}:${minutes}:${seconds}`
      }
    }

    if (props.format === 'mm:ss') {
      time = {
        days: null,
        time: `${minutes}:${seconds}`
      }
    }

    return time
  })

  const initTimer = (timeLeft: number) => {
    let sec = timeLeft / 1000
    let min = sec / 60
    let hours = min / 60
    let days = hours / 24

    days = Math.floor(days)
    hours = Math.floor(hours - (days * 24))
    min = Math.floor(min - (hours * 60) - (days * 1440))
    sec = Math.floor(sec - (min * 60) - (hours * 3600) - (days * 86400))

    timerValues.value.days = days
    timerValues.value.hours = hours
    timerValues.value.minutes = min
    timerValues.value.seconds = sec
  }

  const getTimeStringValue = (value: number) => {
    return value >= 10 ? value : `0${value}`
  }

  const calcTime = () => {
    const localTimerValues = timerValues.value

    if (localTimerValues.seconds) {
      --localTimerValues.seconds
    } else if (localTimerValues.minutes) {
      --localTimerValues.minutes
      localTimerValues.seconds = 59
    } else if (localTimerValues.hours) {
      --localTimerValues.hours
      localTimerValues.minutes = 59
    } else if (localTimerValues.days) {
      --localTimerValues.days
      localTimerValues.hours = 24

      if (!localTimerValues.days) {
        emit('end-days')
      }
    } else {
      interval.value && clearInterval(interval.value)
      emit('timer-end')
    }
  }

  onMounted(() => {
    initTimer(props.timer)

    interval.value = setInterval(() => {
      calcTime()
    }, 1000)
  })

  onBeforeUnmount(() => {
    interval.value && clearInterval(interval.value)
  })
</script>

<style lang="scss">
  .timer {
    color: var(--text-secondary-color);
    text-align: center;
  }
</style>
